export interface IPatientCaseRejectionReasonDriver {
  patientCaseId?: string;
  driverId?: string;
  rrDriverId?: string;
  description?: string;
  patientCase?: any;
  driver?: any;
  rejectionReasonDriver?: any;
}

export const defaultValue: Readonly<IPatientCaseRejectionReasonDriver> = {};
